import { setupSchermataClassifica } from "./finePartita.js";

export default function classifica(k) {
    k.scene("classifica", () => {
        setupSchermataClassifica(k);
    });
}
